import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { UsersService } from "@app/services/users/users.service";
import { RoleEnum } from "@app/enums/role";

@Injectable({
  providedIn: "root",
})
export class RedirectGuard implements CanActivate {
  private _router = inject(Router);
  private _user = inject(UsersService);

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const { route, role } = _route.queryParams;

    const _role = this._user
      .getRoles()
      .filter(r => r.Name !== RoleEnum.ASR)
      .find(r => r.name.toLowerCase() === role?.toLowerCase());

    if (!(route && role) || !_role) return this._router.createUrlTree(["home"]);

    this._user.setCurrentRole(_role);

    try {
      const { path, queryParams } = this._getRouteData(route);

      return this._router.createUrlTree([path], { queryParams });
    } catch (error) {
      return this._router.createUrlTree(["home"]);
    }
  }

  private _getRouteData(route: string) {
    const routeSplit = route.split("?");

    if (routeSplit.length > 2) {
      throw new Error("Invalid route");
    }

    const [path, query] = routeSplit;

    const queryParams =
      query?.split("&").reduce((acc, curr) => {
        const [key, value] = curr.split("=");
        acc[key] = value;
        return acc;
      }, {}) ?? {};

    return { path, queryParams };
  }
}
